// GSAP Text Gradient Scroll Effect
class TextGradientScroll {
  constructor(element, options = {}) {
    this.element = element;
    this.options = {
      type: options.type || "letter", // 'word' or 'letter'
      textOpacity: options.textOpacity || "soft", // 'none', 'soft', 'medium'
      className: options.className || "",
      ...options,
    };

    this.init();
  }

  init() {
    // Add the wrapper class
    this.element.classList.add("text-gradient-scroll");

    // Add custom className if provided and not empty
    if (this.options.className && this.options.className.trim() !== "") {
      this.element.classList.add(this.options.className);
    }

    // Set container styles
    this.element.style.position = "relative";
    this.element.style.display = "flex";
    this.element.style.flexWrap = "wrap";
    this.element.style.margin = "0";

    // Get the original text content
    const originalText = this.element.textContent.trim();
    this.element.textContent = ""; // Clear the element

    // Split text into words
    const words = originalText.split(" ");

    // Create word/letter elements
    words.forEach((word, wordIndex) => {
      const wordSpan = document.createElement("span");
      wordSpan.className = "text-gradient-word";
      wordSpan.style.position = "relative";
      wordSpan.style.marginRight = "0.8rem";
      wordSpan.style.marginTop = "0.5rem";
      wordSpan.style.display = "inline-block";

      if (this.options.type === "word") {
        this.createWordElement(word, wordSpan);
      } else {
        this.createLetterElement(word, wordSpan);
      }

      this.element.appendChild(wordSpan);
    });

    // Set up GSAP ScrollTrigger
    this.setupGSAPAnimation();
  }

  createWordElement(word, wordSpan) {
    // Create a single span that will animate
    const textSpan = document.createElement("span");
    textSpan.textContent = word;
    textSpan.style.transition = "all 0.5s";
    textSpan.style.opacity = "0";
    textSpan.style.position = "relative";
    textSpan.style.zIndex = "1";

    wordSpan.appendChild(textSpan);
  }

  createLetterElement(word, wordSpan) {
    const letters = word.split("");

    letters.forEach((letter) => {
      const letterSpan = document.createElement("span");
      letterSpan.className = "text-gradient-letter";

      // Create a single span that will animate
      const textSpan = document.createElement("span");
      textSpan.textContent = letter;
      textSpan.style.transition = "all 0.5s";
      textSpan.style.opacity = "0";
      textSpan.style.position = "relative";
      textSpan.style.zIndex = "1";

      letterSpan.appendChild(textSpan);
      wordSpan.appendChild(letterSpan);
    });
  }

  getOpacityValue() {
    switch (this.options.textOpacity) {
      case "none":
        return "0";
      case "soft":
        return "0.1";
      case "medium":
        return "0.3";
      default:
        return "0.1";
    }
  }

  getOpacityClass() {
    switch (this.options.textOpacity) {
      case "none":
        return "opacity-0";
      case "soft":
        return "opacity-10";
      case "medium":
        return "opacity-30";
      default:
        return "opacity-10";
    }
  }

  setupGSAPAnimation() {
    // Get all text elements that will animate
    const textElements = this.element.querySelectorAll(
      ".text-gradient-word span, .text-gradient-letter span",
    );

    // Set initial state
    gsap.set(textElements, { opacity: 0 });

    // Create the ScrollTrigger animation
    gsap.to(textElements, {
      opacity: 1,
      duration: 0.6,
      stagger: this.options.type === "word" ? 0.08 : 0.015,
      ease: "power2.out",
      scrollTrigger: {
        trigger: this.element,
        start: "top 85%",
        end: "bottom 15%",
        toggleActions: "play none none reverse",
        scrub: false,
        // markers: true, // Uncomment for debugging
      },
    });
  }
}

// Initialize text gradient scroll on elements with data-text-gradient attribute
document.addEventListener("DOMContentLoaded", function () {
  // Wait for GSAP to be available
  if (typeof gsap !== "undefined") {
    const gradientElements = document.querySelectorAll("[data-text-gradient]");

    gradientElements.forEach((element) => {
      const options = {
        type: element.dataset.type || "letter",
        textOpacity: element.dataset.textOpacity || "soft",
        className: element.dataset.className || "",
      };

      // Only create instance if element has content
      if (element.textContent && element.textContent.trim() !== "") {
        new TextGradientScroll(element, options);
      }
    });
  } else {
    console.warn("GSAP not loaded. Text gradient scroll effect will not work.");
  }
});

// Export for use in other modules
window.TextGradientScroll = TextGradientScroll;
